import {AdjacencyMap} from './GraphUtilConstants';

/**
 * Determines if adding an edge from sourceNodeId to targetNodeId would create a cycle.
 * Uses DFS to check if there's already a path from target to source.
 *
 * @param adjacencyMap - Map of node IDs to their adjacent nodes (directed edges)
 * @param sourceNodeId - The source node of the proposed edge
 * @param targetNodeId - The target node of the proposed edge
 * @returns true if adding the edge would create a cycle, false otherwise
 */
export default function wouldEdgeCreateCycle(
  adjacencyMap: AdjacencyMap,
  sourceNodeId: string,
  targetNodeId: string
): boolean {
  // Check if there's a path from target to source (which would create a cycle if we add source->target)
  const visited = new Set<string>();
  const stack: Array<string> = [targetNodeId];

  while (stack.length > 0) {
    const current = stack.pop()!;

    if (current === sourceNodeId) {
      // Found a path from target back to source - would create a cycle
      return true;
    }

    if (visited.has(current)) {
      continue;
    }
    visited.add(current);

    const neighbors = adjacencyMap[current];
    if (neighbors) {
      for (const neighbor of neighbors) {
        if (!visited.has(neighbor)) {
          stack.push(neighbor);
        }
      }
    }
  }

  return false;
}
